import { render, staticRenderFns } from "./salesCheque.vue?vue&type=template&id=1f16ded4"
import script from "./salesCheque.vue?vue&type=script&lang=js"
export * from "./salesCheque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports